import getAuctions from '../../../api/getAuctions'
import AuctionsListing from '../../../components/AuctionsListing/AuctionsListing'
import redirectAuctionsByFavoriteLocation from '@utilities/redirects/redirectAuctionsByFavoriteLocation'

export async function getServerSideProps(context: any) {
  const route = 'category'

  const redirect = await redirectAuctionsByFavoriteLocation(context, route)
  if (redirect) return redirect

  let apiError = ''
  const auctions = await getAuctions(context, route).catch(
    (e) => (apiError = (e.response?.data || e).message)
  )
  if (apiError.match(/java\.lang\.String.*java\.lang\.Integer/)) {
    // prevents long numeric page-id throw
    return {
      redirect: {
        destination: '/category/all/1',
        permanent: false,
      },
    }
  }
  return { props: auctions }
}

export default function Category(props: any) {
  return (
    <AuctionsListing
      props={props}
      title="Current Auctions Online by BidFTA.com"
      previewDescription="View all live and ending soon auctions online powered by BidFTA. From couches to computers, we have something for everyone."
      baseUrl="/category"
    />
  )
}
